import { useTranslation } from 'react-i18next'
import { Box, Text } from '@chakra-ui/react'
import { colors } from '../../../utilities/colors'
import { priceOptionColors, priceOptionIcons } from './priceOptions'

export default function PriceOptionCard({ option, onClick, horizontalOrientation, vehicleCount = 1 }) {
  const { t } = useTranslation()
  const accent = priceOptionColors[option.type] || colors.grey300
  const Icon = priceOptionIcons[option.type]
  const showPerVehicle = vehicleCount > 1
  const perVehiclePrice = showPerVehicle ? option.price / vehicleCount : null
  const formatMoney = (value) => Math.round(value).toLocaleString()
  const hasEta = !!(option.delivery_eta || option.delivery_time)

  if (horizontalOrientation) {
    return (
      <Box
        w="full"
        px={4}
        py={3}
        borderRadius="md"
        border="1px solid"
        borderColor={colors.deepOcean}
        bg={colors.grey900}
        borderLeft="4px solid"
        borderLeftColor={accent}
        display="flex"
        flexDirection="column"
        gap={2}
        _hover={onClick ? { borderColor: accent, cursor: 'pointer' } : undefined}
        transition="all 0.2s"
        onClick={onClick}
      >
        <Box display="flex" alignItems="center" gap={4}>
          {Icon && <Box as={Icon} size="20px" color={accent} flexShrink={0} />}
          <Text fontSize="sm" fontWeight="bold" color={accent} textTransform="capitalize" flexShrink={0}>
            {option.type}
          </Text>
          <Box display="flex" flexDirection="column" alignItems="flex-end" flexShrink={0} ml="auto">
            <Text fontSize="lg" fontWeight="bold" color={colors.grey100}>
              ${formatMoney(showPerVehicle ? perVehiclePrice : option.price)}
              {showPerVehicle && (
                <Text as="span" fontSize="xs" fontWeight="normal" color={colors.grey300}>
                  {' '}{t('/vehicle')}
                </Text>
              )}
            </Text>
            {showPerVehicle && (
              <Text fontSize="xs" color={colors.grey300}>
                ${formatMoney(option.price)} {t('total')}
              </Text>
            )}
          </Box>
        </Box>
        {hasEta && (
          <Box display="flex" alignItems="center" gap={4} justifyContent="space-between">
            <Text fontSize="xs" color={colors.grey300}>
              {t('ETA')}: {[option.delivery_eta, option.delivery_time].filter(Boolean).join(' · ')}
            </Text>
          </Box>
        )}
      </Box>
    )
  }

  return (
    <Box
      flex={1}
      p={4}
      borderRadius="md"
      border="1px solid"
      borderColor={colors.deepOcean}
      bg={colors.grey900}
      borderTop="4px solid"
      borderTopColor={accent}
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={3}
      _hover={onClick ? { borderColor: accent, cursor: 'pointer' } : undefined}
      transition="all 0.2s"
      onClick={onClick}
    >
      {Icon && <Box as={Icon} size="24px" color={accent} />}
      <Text fontSize="md" fontWeight="bold" color={accent} textTransform="capitalize">
        {option.type}
      </Text>
      <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
        <Text fontSize="2xl" fontWeight="bold" color={colors.grey100}>
          ${formatMoney(showPerVehicle ? perVehiclePrice : option.price)}
          {showPerVehicle && (
            <Text as="span" fontSize="sm" fontWeight="normal" color={colors.grey300}>
              {' '}{t('/vehicle')}
            </Text>
          )}
        </Text>
        {showPerVehicle && (
          <Text fontSize="xs" color={colors.grey300}>
            ${formatMoney(option.price)} {t('total')}
          </Text>
        )}
      </Box>
      {hasEta && (
        <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
          {option.delivery_eta && (
            <Text fontSize="sm" color={colors.grey300}>
              {t('ETA')}: {option.delivery_eta}
            </Text>
          )}
          {option.delivery_time && (
            <Text fontSize="sm" color={colors.grey300}>
              {option.delivery_time}
            </Text>
          )}
        </Box>
      )}
    </Box>
  )
}
